/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { gaWrapper } from 'helpers/analytics';
import s from './StickyOpenInApp.scss';

class StickyOpenInApp extends React.Component {
  constructor() {
    super();
    this.state = {
      isShow: false,
    };
  }

  handleShow = () => {
    if (window.scrollY > this.prev) {
      this.setState({ isShow: false });
      if (typeof this.props.openInAppToggle === 'function') {
        this.props.openInAppToggle(false);
      }
    } else {
      this.setState({ isShow: true });
      if (typeof this.props.openInAppToggle === 'function') {
        this.props.openInAppToggle(true);
      }
    }
    this.prev = window.scrollY;
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleShow);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleShow);
  }

  handleOpenInAppClick = () => {
    gaWrapper(
      'send',
      'event',
      `app_download_hook`,
      'sticky_footer_open_toi_app',
      'click',
    );
    // e.preventDefault();
    // const seturl = this.props.getAppLink();
    // const isIOS =
    //   /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    // if (isIOS) {
    //   // const openinApp = ;
    //   window.open(seturl, '_blank');
    //   // setTimeout(() => {
    //   //   openinApp.close();
    //   // }, 10000);
    // } else {
    //   window.location.href = seturl;
    // }
  };

  render() {
    const showStickyClass = this.state.isShow ? s['show-sticky'] : '';
    return (
      <div className={`${s.openinapp} ${showStickyClass}`}>
        <a
          href={this.props.getAppLink()}
          onClick={e => this.handleOpenInAppClick(e)}
        >
          <span>Open</span> App
        </a>
      </div>
    );
  }
}

StickyOpenInApp.propTypes = {
  getAppLink: PropTypes.func.isRequired,
  openInAppToggle: PropTypes.func,
};

StickyOpenInApp.defaultProps = {
  openInAppToggle: undefined,
};

export default StickyOpenInApp;
